/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_NotesInputs */

const en_recipe_notes = /** @type {(inputs: Recipe_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My notes`)
};

const de_recipe_notes = /** @type {(inputs: Recipe_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Notizen`)
};

/**
* | output |
* | --- |
* | "My notes" |
*
* @param {Recipe_NotesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_notes = /** @type {((inputs?: Recipe_NotesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_NotesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_notes(inputs)
	return en_recipe_notes(inputs)
});